import Icon from 'components/Icon/Icon';
import BackButton from 'components/BackButton/BackButton';
import {
  BackWrapper,
  CompanyDetailsWrapper,
  CompanyName,
  Container,
  ContentWrapper,
  editIconStyling,
  IconWrapper,
  imageContainerStyle,
  imageStyle,
  InfoText,
  RowGap,
  ToggleStateLabel,
  ToggleStateWrapper,
} from './BuyersSinglePage.styled';
import { Info, PencilSimple } from '@phosphor-icons/react';
import { COLORS } from 'assets/styled';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { RoutesConfig } from 'navigation/routes';
import {
  AdaptiveImage,
  AdaptiveImageType,
} from 'components/AdaptiveImage/AdaptiveImage';
import { useEditBuyer, useGetSingleBuyer } from './hooks';
import { useState } from 'react';
import { EditBuyerReferenceModal } from 'components/Modals/EditBuyerReferenceModal/EditBuyerReferenceModal';
import BuyerModels from './BuyerModels/BuyerModels';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import Tooltip from 'components/Tooltip/Tooltip';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';

const BuyersSinglePage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { isSmallTablet } = useBreakpointFlag();

  const { company } = useSelector((state: IRootReducerState) => state.userInfo);

  // const [isEditReferenceModalOpen, setIsEditReferenceModalOpen] =
  //   useState<boolean>(false);

  const { data: buyerData, isSuccess: isSuccessGetBuyerData } =
    useGetSingleBuyer(Number(id!));

  const { mutate: editBuyer, isLoading: isLoadingEditBuyer } = useEditBuyer();

  return (
    <Container>
      <BackWrapper>
        <BackButton
          destination={t('Buyers')}
          onClick={() => navigate(RoutesConfig.Buyers.fullPath)}
        />
      </BackWrapper>
      <ContentWrapper>
        <AdaptiveImage
          imageStyle={imageStyle}
          containerStyle={imageContainerStyle}
          imageUrl={buyerData?.logo_url}
          type={AdaptiveImageType.COMPANY}
          isSuccess={isSuccessGetBuyerData}
        />
        <CompanyDetailsWrapper>
          <CompanyName>{buyerData?.name}</CompanyName>
          <RowGap>
            <InfoText>{t('Reference number')}:</InfoText>
            <InfoText>{buyerData?.customer_number}</InfoText>
            <ToggleStateWrapper>
              <ToggleStateLabel>
                {buyerData?.is_active ? t('Active') : t('Inactive')}
              </ToggleStateLabel>
              <ToggleSwitch
                isChecked={buyerData?.is_active}
                onClick={() => {
                  if (isLoadingEditBuyer) {
                    return;
                  }
                  editBuyer({
                    id: Number(id!),
                    isActive: !buyerData.is_active,
                  });
                }}
                size={isSmallTablet ? 'small' : 'large'}
              />
              <Tooltip
                content={t(
                  "If a buyer is not active, the buyer cannot place an order. If a buyer is active: use the 'Internal Ordering' and 'External Ordering' to manage the access."
                )}
              >
                <Icon svg={Info} size={20} color={COLORS.GREEN} />
              </Tooltip>
            </ToggleStateWrapper>
            {/* {buyerData?.customer_number && (
              <IconWrapper>
                <Icon
                  svg={PencilSimple}
                  color={COLORS.GREEN}
                  wrapperStyle={editIconStyling}
                  onClick={() => setIsEditReferenceModalOpen(true)}
                />
              </IconWrapper>
            )} */}
          </RowGap>
        </CompanyDetailsWrapper>
      </ContentWrapper>

      <BuyerModels sellerId={Number(company.id!)} buyerId={Number(id!)} />

      {/* <EditBuyerReferenceModal
        isOpen={isEditReferenceModalOpen}
        setIsOpen={setIsEditReferenceModalOpen}
        onConfirm={(reference: string) => {
          const dto: IEditBuyerDTO = {
            id: Number(id!),
            reference,
          };
          editBuyer(dto, {
            onSuccess: () => {
              setIsEditReferenceModalOpen(false);
            },
          });
        }}
        title={t('Edit reference for {{ENTITY}}').replace(
          '{{ENTITY}}',
          buyerData?.name
        )}
        initialValue={buyerData?.customer_number}
        isLoading={isLoadingEditBuyer}
      /> */}
    </Container>
  );
};

export default BuyersSinglePage;
